import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import WPEvents from './WPEvents.component';

/** @namespace Pwa/Component/WPEvents/Container */
export class WPEventsContainer extends PureComponent {
    static propTypes = {
        eventType: PropTypes.string,
        eventKey: PropTypes.string,
        contentName: PropTypes.string,
        data: PropTypes.object,
    };

    static defaultProps = {
        contentName: '',
        data: {},
    };

    componentDidMount() {
        this.fireWPEvent();
    }

    fireWPEvent() {
        const { wph } = window;
        const { eventType, eventKey, contentName, data } = this.props;

        if (wph && contentName) {
            wph(eventType, eventKey, this.getProcessedData(data, contentName));
        }
    }

    getProcessedData(data, contentName) {
        switch (contentName) {
            case 'ViewProduct':
                return {
                    content_name: 'ViewProduct',
                    contents: [
                        {
                            id: `${data?.id}`,
                            name: data?.name,
                            price: Number(data?.price_range?.minimum_price?.final_price?.value?.toFixed(2)),
                            category: data?.categories[data.categories.length - 1]?.name,
                            quantity: data?.stock_item?.min_sale_qty,
                            in_stock: data?.stock_item?.in_stock,
                        },
                    ],
                };

            case 'ProductList':
                const products = data?.products?.map((product) => ({
                    id: `${product?.id}`,
                    name: product?.name,
                    category: data?.category?.name || '',
                    in_stock: product?.stock_item?.in_stock,
                    price: Number(product?.price_range?.minimum_price?.final_price?.value?.toFixed(2)),
                }));

                return {
                    content_name: 'ProductList',
                    contents: products,
                };

            case 'Purchase':
                const orderedProducts = data?.order_products?.map((product) => ({
                    id: `${product?.id}`,
                    name: product?.name,
                    price: Number(product?.unit_price?.toFixed(2)),
                    quantity: product?.qty,
                    category: product?.categories[product?.categories.length - 1]?.name,
                    in_stock: true,
                }));

                return {
                    transaction_id: data?.order_number,
                    value_gross: Number(Number(data?.total)?.toFixed(2)),
                    shipping_cost: Number(data?.shipping_and_handling?.toFixed(2)),
                    contents: orderedProducts,
                };

            default:
                return data;
        }
    }

    containerProps() {
        return this.props;
    }

    render() {
        return <WPEvents {...this.containerProps()} />;
    }
}

export default WPEventsContainer;
